import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';

function useDefaultLanguage() {
    const { i18n } = useTranslation();
    const [cookies] = useCookies(['lang']);
    const { lang } = cookies;
    useEffect(() => {
        i18n.changeLanguage(lang || navigator.language);
    }, [lang]);
}

export default useDefaultLanguage;
